import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PesquisaComponent } from './pesquisa.component';
import { FiltrosComponent } from './filtros/filtros.component';
import { ResultadosPesquisaComponent } from './filtros/resultados/resultados-pesquisa.component';
import { FiltrosService } from './filtros/filtros.service';
import { CabecalhoPesquisaComponent } from './cabecalho/cabecalho-pesquisa.component';
import { ResultadoModule } from 'src/app/resultado/resultado.module';
import { RodapeModule } from 'src/app/rodape/rodape.module';
import {RdsModalModule} from '../../shared/rds/rds-modal.module';

@NgModule({
  declarations: [
    CabecalhoPesquisaComponent,
    PesquisaComponent,
    FiltrosComponent,
    ResultadosPesquisaComponent
  ],
  imports: [
    RodapeModule,
    CommonModule,
    FormsModule,
    ResultadoModule,
    RdsModalModule
  ],
  providers: [
    FiltrosService
  ]
})
export class PesquisaModule { }
